import React from 'react';
import { Box, Typography, Button, Stack, Chip } from '@mui/material';

export interface EmptyStatePrompt {
  label: string;
  onClick: () => void;
}

export interface SectionEmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  prompts?: EmptyStatePrompt[];
}

const SectionEmptyState: React.FC<SectionEmptyStateProps> = ({
  icon,
  title,
  description,
  actionLabel,
  onAction,
  prompts,
}) => (
  <Box
    sx={{
      textAlign: 'center',
      py: 4,
      px: 2,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 1.5,
    }}
  >
    {icon && <Box sx={{ color: 'primary.light', mb: 0.5 }}>{icon}</Box>}
    <Typography variant="h6" color="text.secondary">
      {title}
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420 }}>
      {description}
    </Typography>
    {actionLabel && onAction && (
      <Button variant="contained" size="small" onClick={onAction} sx={{ mt: 0.5 }}>
        {actionLabel}
      </Button>
    )}
    {prompts && prompts.length > 0 && (
      <Stack direction="row" flexWrap="wrap" justifyContent="center" gap={1} sx={{ mt: 1, maxWidth: 520 }}>
        {prompts.map((p) => (
          <Chip
            key={p.label}
            label={p.label}
            variant="outlined"
            size="small"
            onClick={p.onClick}
            sx={{ cursor: 'pointer', maxWidth: '100%', height: 'auto', '& .MuiChip-label': { whiteSpace: 'normal', py: 0.75 } }}
          />
        ))}
      </Stack>
    )}
  </Box>
);

export default SectionEmptyState;
